import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./RegisterOTP.css"
import { useDispatch, useSelector } from 'react-redux';
import { register_OTP_request, register_OTP_verify, setSuccess } from '../../../Redux/Slices/Pages/Auth/LoginSlice';
import { bookizapLogo } from '../../../Assets/Icons/IconsIndex';

const RegisterOTP = ({ email, otp, setOtp, onSuccess, onClose }) => {
  const isSuccess = useSelector((state) => state.login.isSuccess);
  const ResponseMessage = useSelector((state) => state.login.message);

  const dispatch = useDispatch();
  const [timer, setTimer] = useState(30);
  const [canResend, setCanResend] = useState(false);
  const [resendCount, setResendCount] = useState(0);
  const [message, setMessage] = useState(null);
  const [isVerifying, setIsVerifying] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let countdown;
    if (timer > 0 && !canResend) {
      countdown = setTimeout(() => setTimer((prev) => prev - 1), 1000);
    } else if (timer === 0) {
      setCanResend(true);
    }
    return () => clearTimeout(countdown);
  }, [timer, canResend]);

  const handleOtpChange = (value) => {
    // Only allow digits and limit to 6 characters
    const numericValue = value.replace(/\D/g, '').slice(0, 6);
    setOtp(numericValue);
  };

  const handleResendOtp = async () => {
    if (resendCount >= 3) {
      setMessage({ text: "Maximum OTP request attempts expired.", type: "error" });
      setTimeout(() => setMessage(null), 3000);
      return;
    }
    try {
      dispatch(register_OTP_request(email));
       setOtp("");
      setMessage({ type: "success", text: "OTP sent successfully!" });
      setTimer(30);
      setCanResend(false);
      setResendCount((prev) => prev + 1);
      setTimeout(() => setMessage(null), 3000);
    } catch (error) {
      setMessage({ text: error.response?.data?.message || "Failed to resend OTP.", type: "error" });
      setTimeout(() => setMessage(null), 3000);
    }
  };

  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setMessage({ text: "Please enter complete OTP", type: "error" });
      setTimeout(() => setMessage(null), 3000);
      return;
    }
    
    setIsVerifying(true);
    dispatch(register_OTP_verify(email, otp));
    const numericOtp = Number(otp); // Convert OTP to a number
    console.log(numericOtp, "otp ");
    
    // Reset verifying state after a delay
    setTimeout(() => {
      setIsVerifying(false);
    }, 2000);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && otp.length === 6) {
      handleVerifyOtp();
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setSuccess(false)); // Reset success flag
      if (onSuccess) onSuccess(); // Let parent decide what to do
    }
  }, [isSuccess, dispatch, onSuccess]);

  return (
    <>
      <div className="register-otp-overlay fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="register-otp-container">
          <div className="register-otp-card">
            {/* Close button */}
            {onClose && (
              <button className="register-close-btn" onClick={onClose}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
            )}

            {/* Header */}
            <div className="register-otp-header">
              <div className="flex items-center justify-center">
                <img src={bookizapLogo} alt="Bookizap Logo" className="w-32 h-32" />
              </div>
              <h2 className="register-otp-title">VERIFICATION CODE</h2>
              <p className="register-otp-subtitle">
                We've sent a 6-digit code to<br/>
                <span className="register-email-highlight">{email}</span>
              </p>
            </div>

            {/* OTP Input */}
            <div className="register-otp-input-container">
              <input
                type="text"
                className="register-otp-input"
                value={otp}
                onChange={(e) => handleOtpChange(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="000000"
                maxLength={6}
                autoComplete="one-time-code"
              />
            </div>

            {/* Message */}
            {message && (
              <div className={`register-otp-message ${message.type}`}>
                {message.text}
              </div>
            )}

            {/* Verify Button */}
            <button
              className={`register-verify-btn ${isVerifying ? 'verifying' : ''}`}
              onClick={handleVerifyOtp}
              disabled={isVerifying || otp.length !== 6}
            >
              {isVerifying ? (
                <div className="register-loading-spinner"></div>
              ) : (
                'VERIFY OTP'
              )}
            </button>

            {/* Resend Section */}
            <div className="register-resend-section">
              {canResend ? (
                resendCount < 3 ? (
                  <button className="register-resend-btn" onClick={handleResendOtp}>
                    Resend OTP
                  </button>
                ) : (
                  <p className="register-max-attempts">Maximum OTP request attempts expired</p>
                )
              ) : (
                <p className="register-timer-text">
                  Not Receive OTP? <span className="register-timer">Resend OTP in {timer} seconds</span>
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="register-bg-decoration">
          <div className="register-bg-circle register-bg-circle-1"></div>
          <div className="register-bg-circle register-bg-circle-2"></div>
          <div className="register-bg-circle register-bg-circle-3"></div>
        </div>
      </div>
    </>
  );
};

export default RegisterOTP;